import constants from "../config/constants";

export const isNullOrEmpty = value => value == null || value === "" || value === undefined;

export const URLWithSearchParams = (inputUrl, searchParams) => {
  const url = new URL(inputUrl);
  url.search = new URLSearchParams(searchParams).toString();
  return url;
};

export const isLegalRut = value => {
  const number = parseInt(value.toString().substring(0, value.length - 1));
  return constants.MIN_NUMBER_RUT_LEGAL_PERSON <= number;
};

export const isLegalRuc = value => {
  const firstDigits = value.toString().slice(0, 2);
  return constants.RUC_LEGAL_PERSON_BEGINNING === parseInt(firstDigits);
};

export const isNaturalRuc = value => {
  const firstDigits = parseInt(value.toString().slice(0, 2));
  return constants.RUC_NATURAL_PERSON_BEGINNINGS.includes(firstDigits);
};
